import { useAppSelector } from "@/store/store";
import {
  CO_ASSIGN,
  CO_DELIVERY_EMAILS,
  CO_MANAGE,
  CO_MARK_DELIVERED,
  CO_SO_NUMBER,
  type CustomOrderPermission,
} from "@/lib/utils/custom-order-permissions";

/**
 * What the signed-in user may see in Custom Orders, from the profile's
 * `customOrderPermissions` (resolved server-side from customOrderRoles).
 * Deny by default: a missing key is false. For rendering only.
 */
export function useCustomOrderPermissions() {
  const status = useAppSelector((state) => state.auth.status);
  const granted = useAppSelector((state) => state.auth.currentUser?.customOrderPermissions);
  const has = (key: CustomOrderPermission) => !!granted?.includes(key);

  return {
    /** Session still loading — don't redirect or decide yet. */
    isLoading: status === "unknown",
    has,
    canManage: has(CO_MANAGE),
    canSetSoNumber: has(CO_SO_NUMBER),
    canMarkDelivered: has(CO_MARK_DELIVERED),
    canSeeDeliveryEmails: has(CO_DELIVERY_EMAILS),
    canAssign: has(CO_ASSIGN),
  };
}

export default useCustomOrderPermissions;
